import React, { useState, useEffect } from 'react';

import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatButton from '@components/common/satUI/SatButton';

const SpecialConditionGradeList = props => {
  const {
    options,
    selectedItems = [],
    onChangeSpecialConditionGrade,
    onClose,
  } = props;

  const [typeOptions, setTypeOptions] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    if (options.length > 0) {
      const types = [...new Set(options.map(option => option.planCode))];

      setTypeOptions(
        types.map(type => options.filter(option => option.planCode === type)),
      );
    }
  }, [options]);

  useEffect(() => {
    if (options.length > 0 && selectedItems.length > 0) {
      const types = [...new Set(options.map(option => option.planCode))];

      setCheckedItems(
        types.map(type => {
          const object = selectedItems.find(item => item.productCode === type);
          return object
            ? [`${object.productCode}_${object.subStandardGrade || ''}`]
            : [];
        }),
      );
    }
  }, [selectedItems]);

  return (
    <React.Fragment>
      <header className="con-header">
        <div className="page-navi">
          <span onClick={onClose} className="btn-back">
            이전
          </span>
        </div>
        <h1 className="page-tit">{'특별조건부 선택'}</h1>
      </header>
      <div className="con-wrap">
        <div className="fbox">
          <div className="wrap-sp-addsel">
            {typeOptions.map((options, index) => {
              return (
                <div className="box" key={index}>
                  <div className="check-box w100">
                    {/* className : list-sp -> check-box w100 */}
                    <SatCheckBox
                      customStyleClass="text-gray" //추가 : 글씨색 변경
                      checkOne
                      value={checkedItems[index]}
                      options={options.map(option => {
                        return {
                          label: `${option.dispName}`,
                          value: `${option.planCode}_${option.code}`,
                        };
                      })}
                      onChange={value =>
                        setCheckedItems(prevState =>
                          prevState.map((item, idx) => {
                            return index === idx
                              ? value.map(item => item.value)
                              : item;
                          }),
                        )
                      }
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="btn-area">
        <div className="box-btns-center">
          <SatButton
            styleClass="btn-s blue btn-wide"
            label="확인"
            onClick={() => onChangeSpecialConditionGrade(checkedItems)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SpecialConditionGradeList;
